import { lazy } from '@atlassian/react-loosely-lazy';
import type { LinkedAlertsField } from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncLinkedAlertsField = lazy<typeof LinkedAlertsField>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-linked-alerts" */ './ui').then(
		(module) => module.LinkedAlertsField,
	),
);
